import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SimpleResponse } from '../models/genericResponse.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { UtilityService } from './shared/utility.service';
import { EngageDigitalLoadRequest } from '../models/engageforms-engage-digital.model';
@Injectable()
export class EngageDigitalService {
  private baseUrl: string;
  private api: string = 'api/EngageDigital';

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  async loadSOdigital(encryptedUser, EngageDigitalLoadRequest: EngageDigitalLoadRequest, isLoad): Promise<any | void> {
    const a = await this.httpClient
      .post<any>(`${this.baseUrl}/LoadSOdigital/${isLoad}`, EngageDigitalLoadRequest, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, EngageDigitalLoadRequest, "r - " + encryptedUser, "EngageDigitalService", "LoadSOdigital"); });
    return a;
  }

  async uploadExcel(encryptedUser: string): Promise<SimpleResponse | void> {
    const a = await this.httpClient
      .post<SimpleResponse>(`${this.baseUrl}/UploadExcel`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser , encryptedUser, "EngageDigitalService", "uploadExcel"); });
    return a;
  }
}
